import React from 'react'
import M01Header from '../modules/M01Header'
import M01HeaderAlternative from '../modules/M01HeaderAlternative'
import M02TeaserNews from '../modules/M02TeaserNews'
import M03Testimonials from '../modules/M03Testimonial'
import M04TeaserMagazine from '../modules/M04TeaserMagazine'
import M05TeaserHomeAlternate from '../modules/M05TeaserHomeAlternate'
import M06TeaserLift from '../modules/M06TeaserLift'
import M07TextImageAlternate from '../modules/M07TextImageAlternate'
import M08BReferencesSliderNew from '../modules/M08BReferencesSliderNew'
import M09BoxRotator from '../modules/M09BoxRotator'
import M10Cards from '../modules/M10Cards'
import M11MediaContainer from '../modules/M11MediaContainer'
import M12Harmonica from '../modules/M12Harmonica'
import M13LiftConfigurator from '../modules/M13LiftConfigurator'
import M14Renovation from '../modules/M14Renovation'
import M15AdvantagesDisadvantages from '../modules/M15AdvantagesDisadvantages'
import M15Table from '../modules/M15Table'
import M16LightboxDetails from '../modules/M16LightboxDetails'
import M17JobsList from '../modules/M17JobsList'
import M18PeopleList from '../modules/M18PeopleList'
import M19MagazineHomepage from '../modules/M19MagazineHomepage'
import M20Copy from '../modules/M20Copy'
import M21Colors from '../modules/M21Colors'
import M22FormBuilder from '../modules/M22FormBuilder'
import M23JobListAbstract from '../modules/M23JobListAbstract'
import M24HubSpotForm from '../modules/M24HubSpotForm'
import M25DetailsAndColors from '../modules/M25DetailsAndColors'
import M26VariantConfigurator from '../modules/M26VariantConfigurator'
import M27EmbeddedPage from '../modules/M27EmbeddedPage'
import M28SalesforceForm from '../modules/M28SalesforceForm'
import M29OnlineIncidentForm from '../modules/M29OnlineIncidentForm'

const ContentBlock = ({ __typename, id, ...rest }) => {
  const mapping = {
    CraftContent_contentBlocks_hero_BlockType: <M01Header key={id} {...rest} />,
    CraftContent_contentBlocks_headerAlternative_BlockType: (
      <M01HeaderAlternative key={id} {...rest} />
    ),
    CraftContent_contentBlocks_twoColumnTeaserSection_BlockType: (
      <M02TeaserNews key={id} {...rest} />
    ),
    CraftContent_contentBlocks_testimonial_BlockType: (
      <M03Testimonials key={id} {...rest} />
    ),
    CraftContent_contentBlocks_magazineFeature_BlockType: (
      <M04TeaserMagazine key={id} {...rest} />
    ),
    CraftContent_contentBlocks_serviceSection_BlockType: (
      <M05TeaserHomeAlternate key={id} {...rest} />
    ),
    CraftContent_contentBlocks_teaserLift_BlockType: (
      <M06TeaserLift key={id} {...rest} />
    ),
    CraftContent_contentBlocks_careersFeature_BlockType: (
      <M07TextImageAlternate key={id} {...rest} />
    ),
    CraftContent_contentBlocks_magazinePage_BlockType: (
      <M19MagazineHomepage key={id} {...rest} />
    ),
    // CraftContent_contentBlocks_referencesSlider_BlockType: (
    //   <M08ReferencesSlider key={id} {...rest} />
    // ),
    CraftContent_contentBlocks_referencesSliderNew_BlockType: (
      <M08BReferencesSliderNew key={id} {...rest} />
    ),
    CraftContent_contentBlocks_boxRotator_BlockType: (
      <M09BoxRotator key={id} {...rest} />
    ),
    CraftContent_contentBlocks_cardsSection_BlockType: (
      <M10Cards key={id} {...rest} />
    ),
    CraftContent_contentBlocks_mediaContainer_BlockType: (
      <M11MediaContainer key={id} {...rest} />
    ),
    CraftContent_contentBlocks_harmonica_BlockType: (
      <M12Harmonica key={id} {...rest} />
    ),
    CraftContent_contentBlocks_liftConfigurator_BlockType: (
      <M13LiftConfigurator key={id} {...rest} />
    ),
    CraftContent_contentBlocks_m14Renovation_BlockType: (
      <M14Renovation key={id} {...rest} />
    ),
    CraftContent_contentBlocks_advantagesDisadvantages_BlockType: (
      <M15AdvantagesDisadvantages key={id} {...rest} />
    ),
    CraftContent_contentBlocks_table_BlockType: <M15Table key={id} {...rest} />,
    CraftContent_contentBlocks_lightboxDetails_BlockType: (
      <M16LightboxDetails key={id} {...rest} />
    ),
    CraftContent_contentBlocks_jobsList_BlockType: (
      <M17JobsList key={id} {...rest} />
    ),
    CraftContent_contentBlocks_peopleList_BlockType: (
      <M18PeopleList key={id} {...rest} />
    ),
    CraftContent_contentBlocks_copy_BlockType: <M20Copy key={id} {...rest} />,
    CraftContent_contentBlocks_colors_BlockType: (
      <M21Colors key={id} {...rest} />
    ),
    CraftContent_contentBlocks_formBuilder_BlockType: (
      <M22FormBuilder key={id} {...rest} />
    ),
    CraftContent_contentBlocks_jobListAbstract_BlockType: (
      <M23JobListAbstract key={id} {...rest} />
    ),
    CraftContent_contentBlocks_hubSpotForm_BlockType: (
      <M24HubSpotForm key={id} {...rest} />
    ),
    CraftContent_contentBlocks_detailsAndColors_BlockType: (
      <M25DetailsAndColors key={id} {...rest} />
    ),
    CraftContent_contentBlocks_variantConfigurator_BlockType: (
      <M26VariantConfigurator key={id} {...rest} />
    ),
    CraftContent_contentBlocks_embeddedPage_BlockType: (
      <M27EmbeddedPage key={id} {...rest} />
    ),
    CraftContent_contentBlocks_salesforceForm_BlockType: (
      <M28SalesforceForm key={id} {...rest} />
    ),
    CraftContent_contentBlocks_onlineIncidentForm_BlockType: (
      <M29OnlineIncidentForm key={id} {...rest} />
    ),
  }

  if (mapping[__typename]) {
    return mapping[__typename]
  }

  return null
}

export default ContentBlock
